import { render, staticRenderFns } from "./TiJianChaXunBackUp.vue?vue&type=template&id=bfb5701a&scoped=true"
import script from "./TiJianChaXunBackUp.vue?vue&type=script&lang=js"
export * from "./TiJianChaXunBackUp.vue?vue&type=script&lang=js"
import style0 from "./TiJianChaXunBackUp.vue?vue&type=style&index=0&id=bfb5701a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb5701a",
  null
  
)

export default component.exports